const messages = {
  CANDIDATE_CREATED: "Candidate successfully created!",
  APPLICATION_UPDATED: "Application successfully updated!",
};

export const interviewDuration = [
  { key: "00:30", value: "30 Minutes" },
  { key: "00:45", value: "45 Minutes" },
  { key: "01:00", value: "1 Hour" },
  { key: "01:30", value: "1.5 Hour" },
  { key: "02:00", value: "2 Hours" },
  { key: "02:30", value: "2.5  Hours " },
  { key: "03:00", value: "3 Hours" },
  { key: "03:30", value: "3.5 Hours" },
  { key: "04:00", value: "4 Hours" },
];

export const ROLE_TALENT_ACQUISITION = "Talent Acquisition";
export const ROLE_INTERVIEW_PANEL = "Interview Panel";
export const ROLE_HR = "HR";
export const ROLE_APPLICATION_MANAGER = "Application Manager";
export const ROLE_DEPARTMENT_HEAD = "Department Head";
export const STATUSES_SKIP_VALIDATION = ["no-show", "no show"];

export const isNoShowStatus = statusName => {
  if (!statusName) return false;
  const normalizedName = statusName.toLowerCase();
  return STATUSES_SKIP_VALIDATION.some(pattern =>
    normalizedName.includes(pattern.toLowerCase()),
  );
};

export default messages;
